import { useAuth } from "context/AuthContext";

import { Outlet } from "react-router-dom";
import Login from "pages/Login/Login";
import { Oval } from "react-loader-spinner";
const ProtectedRoutes = () => {
  const { user } = useAuth();

  return user ? (
    <Outlet />
  ) : user === undefined ? (
    <div className=" flex flex-col  flex-1 w-full h-screen justify-center items-center space-y-5 ">
      <h1 className="text-5xl text-white">KAUST GUARDIAN</h1>
      <img src={"/Logo.png"} alt="Logo" className="w-64" />
      <Oval height={60} width={60} color="royalblue" secondaryColor="white" />
    </div>
  ) : (
    <Login />
  );
};

export default ProtectedRoutes;
